



























import Vue from 'vue';
import { EAccountTabs, IMenuItems } from '@/types/auth/account';
import truffleKitIcons from '@/utils/truffleKitIcons';

const ACCOUNT_URL = '/account';

export default Vue.extend({
  name: 'TheAccountDropDownMenu',

  props: {
    isShowMenu: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    menuItems(): Array<IMenuItems> {
      return [
        {
          name: this.$t('pages.account.menu.profile') as string,
          icon: truffleKitIcons.menuPfofile,
          link: this.formatLink(EAccountTabs.PROFILE),
        },
        {
          name: this.$t('pages.account.menu.settings') as string,
          icon: truffleKitIcons.menuSettings,
          link: this.formatLink(EAccountTabs.SETTINGS),
        },
      ];
    },
    logoutIcon(): string {
      return truffleKitIcons.menuLogout;
    },
  },

  methods: {
    formatLink(tabName): string {
      const urlSearchParams = new URLSearchParams(location.search);
      urlSearchParams.set('tab', tabName);

      return `${ACCOUNT_URL}?${urlSearchParams.toString()}`;
    },
    logout() {
      this.$store.commit('logOut');
      window.location.href = '/';
    },
  },
});
